import { Link } from "react-router";
import type { MegaMenuSubItem } from "@/features/navigation/components/MegaMenu/types/megaMenu.types";
import { cn } from "@/shared/utils/style.util";

type MegaMenuListItemProps = {
  item: MegaMenuSubItem
  onItemClick?: () => void
};

export const MegaMenuListItem = ({ item, onItemClick }: MegaMenuListItemProps) => {
  const Icon = item.icon;

  return (
    <div>
      <Link
        to={item.to}
        onClick={onItemClick}
        role="menuitem"
        className={cn(
          "group relative block rounded-lg p-3 transition-colors duration-200",
          "hover:bg-primary-50 dark:hover:bg-primary-900/20",
        )}
      >
        <div className="flex items-start gap-3">
          {Icon && (
            <div className={cn(
              "flex-shrink-0 mt-0.5",
              "text-gray-500 dark:text-gray-400",
              "group-hover:text-primary-600 dark:group-hover:text-primary-400",
              "transition-colors duration-200",
            )}
            >
              <Icon className="w-5 h-5" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <div className={cn(
                "text-sm font-medium leading-none",
                "text-gray-900 dark:text-white",
                "group-hover:text-primary-600 dark:group-hover:text-primary-400",
                "transition-colors duration-200",
              )}
              >
                {item.label}
              </div>
              {item.badge && (
                <span className={cn(
                  "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
                  "bg-primary-100 text-primary-800",
                  "dark:bg-primary-900/30 dark:text-primary-400",
                )}
                >
                  {item.badge}
                </span>
              )}
            </div>
            {item.description && (
              <p className={cn(
                "text-xs leading-snug line-clamp-2",
                "text-gray-600 dark:text-gray-400",
                "group-hover:text-gray-700 dark:group-hover:text-gray-300",
                "transition-colors duration-200",
              )}
              >
                {item.description}
              </p>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};
